import React from "react";
import OrderForm from "../components/Form/OrderForm";

const OrderPage = () => {
  return <OrderForm />;
};

export default OrderPage;
